//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { CustomFieldValueInputItem } from './CustomFieldValueInputItem';
import { CustomFieldType } from './Enums';

export class CustomFieldDropDownListValueInputItem extends CustomFieldValueInputItem {
    Option: string | null = null;
    override readonly FieldType: CustomFieldType = CustomFieldType.DropDownList;

    constructor(initializer?: Partial<Omit<CustomFieldDropDownListValueInputItem, "FieldType">>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static override readonly ClassName: string = "CustomFieldDropDownListValueInputItem";
}
